import { Path, SVG } from '@wordpress/primitives';

export default (
	<SVG xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" style={ { fill: "none" } } stroke="currentColor" strokeWidth="1.5">
		<Path d="M15 15L18.5 11L15 7M18.5 11H8C5 11 4.75 13.8 4.75 17" vectorEffect="non-scaling-stroke" />
	</SVG>
);
